module.exports = __webpack_public_path__ + "static/img/LEWIS-HOUNDSOME.bee402b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LEWIS-HOUNDSOME.jpg
// module id = tAQ6
// module chunks = 0